import { Cloud } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import InvalidHealthCenterError from '../../../../errors/InvalidHealthCenterError';

export const getPortersQueryOptions = (healthCenterId: string, qrCodeKey: string) =>
  queryOptions({
    queryKey: ['get-porters', healthCenterId],
    queryFn: async () => {
      try {
        const result = await Cloud.getPorters({ healthCenterId, qrCodeKey });
        return result;
      } catch {
        throw new InvalidHealthCenterError();
      }
    },
    enabled: !!healthCenterId && !!qrCodeKey,
  });
